<template>
	<b-overlay :show="showSpinner" rounded="sm">
		<div>
			<div
				v-if="
					!particularView &&
						($route.params.candidateType == 'G' ||
							$route.params.candidateType == 'R')
				"
				class="h-100"
			>
				<!-- display group details -->
				<template v-if="allData.data.length">
					<div class="d-flex justify-content-between px-1">
						<div
							v-if="
								$route.params.candidateType == 'G' ||
									$route.params.candidateType == 'R'
							"
							class="statstext mt-2 mb-2"
						>
							View Group
						</div>
						<div
							class="mr-1 pointer statstext txt-underline mt-2"
							@click="exportExcelReport()"
						>
							Export Excel
						</div>
					</div>
					<div class="mt-2">
						<div class="d-flex justify-content-between shareview-details p-3">
							<div class="d-flex flex-column">
								<span class="shareview-details-text"
									>"Candidates/Individuals" in Group</span
								>
								<span class="shareview-details-bold">{{
									allData.data.length
								}}</span>
							</div>
							<div class="d-flex flex-column">
								<span class="shareview-details-text">Created On</span>
								<span class="shareview-details-bold">{{
									allData.createdAt.slice(0, 10) | datefilter
								}}</span>
							</div>
						</div>
						<div class="mt-4 grpviewselectedCandidateContainer">
							<div
								class="mb-3 email p-2"
								v-for="(canDetails, index) in allData.data"
								:key="index"
							>
								<div class="d-flex justify-content-between">
									<div class="d-flex">
										<span
											><img
												v-b-popover.hover.top="'Individual'"
												src="../../assets/icons/Reports/singlepep.svg"
												alt=""
												class="mr-2"
										/></span>
										<div
											class="shareview-details-email mt-1 pointer"
											@click="gotoFourthPageGroup(canDetails)"
										>
											{{ canDetails.emailID }}
										</div>
									</div>
									<div class="d-flex align-items-center">
										<div class="mr-4">
											<!-- Red Icon -->

											<img
												src="../../assets/icons/proctoring/ongoing.svg"
												alt=""
												v-b-popover.hover.top="'Ongoing'"
												v-if="canDetails.testStatus == false"
											/>
											<img
												src="../../assets/icons/proctoring/completed.svg"
												alt=""
												v-b-popover.hover.top="'Completed'"
												v-else-if="
													canDetails.testStatus == true &&
														canDetails.evaluated == false
												"
											/>
											<img
												v-b-popover.hover.top="'Evaluated'"
												src="../../assets/icons/proctoring/evaldone.svg"
												alt=""
												v-else-if="canDetails.evaluated == true"
											/>
											<img
												v-b-popover.hover.top="'Yet To Start'"
												src="../../assets/icons/proctoring/yetToStart.svg"
												alt=""
												v-else
											/>
										</div>
										<div>
											<img
												v-b-popover.hover.top="'View Details'"
												class="pointer"
												@click="viewParticularCandidate(canDetails)"
												src="../../assets/eyeicon.svg"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<div
					v-else-if="allData.data.length == 0"
					class="d-flex align-items-center justify-content-center proct-notest-container"
				>
					<img src="../../assets/nogroupdata.svg" alt="" />
				</div>
			</div>
			<!-- display particular candidate test details in the group-->
			<div
				v-else-if="
					particularView &&
						($route.params.candidateType == 'G' ||
							$route.params.candidateType == 'R')
				"
				:class="
					!candidateDetails.data
						? 'd-flex justify-content-center align-items-center h-100'
						: ''
				"
			>
				<template v-if="candidateDetails.data">
					<div class="d-flex justify-content-between align-items-center">
						<div class="d-flex align-items-center">
							<img
								v-if="
									$route.params.candidateType == 'G' ||
										$route.params.candidateType == 'R'
								"
								src="../../assets/icons/Reports/bckarrow.svg"
								alt=""
								class="pointer"
								@click="closeParticularCandidate()"
							/>
							<div class="ml-1 canddet-txt">Candidate Details</div>
						</div>
						<div
							class="mr-1 pointer gotoprocttxt"
							v-if="
								tabIndex < 3 &&
									showProctoring != 'yetToStart' &&
									totalData.data.length > 0 &&
									roles.includes('GET_PROCTORING_DETAILS')
							"
							@click="$emit('store-payload'), gotoFourthPage(candidateDetails)"
						>
							Go to proctoring
						</div>
					</div>
					<div class="d-flex align-items-center mt-4">
						<div class="pvd-profileimg">
							<img
								src="../../assets/icons/proctoring/dp.png"
								alt=""
								class="w-100 h-100"
							/>
						</div>
						<div class="d-flex pvd-dp-text flex-column ml-3">
							<div class="text-truncate">
								{{ candidateDetails.candidatename }}
							</div>
							<div class="text-truncate">{{ candidateDetails.email }}</div>
						</div>
					</div>
					<div class="d-flex justify-content-between align-items-center mt-5">
						<div class="d-flex flex-column" style="width: 45%">
							<div class="answertext">Topic Name</div>
							<div class="text-truncate">
								<span
									class="d-inline-block quesbank-number-text text-truncate"
									style="max-width: 100%"
									v-b-popover.hover.top="
										`${getFormattedTopicName(candidateDetails.topicName)}`
									"
								>
									{{ getFormattedTopicName(candidateDetails.topicName) }}
								</span>
							</div>
						</div>
						<div class="d-flex flex-column" style="width: 55%">
							<div class="answertext">Test Name</div>
							<div class="text-truncate">
								<span
									class="d-inline-block quesbank-number-text text-truncate"
									style="max-width: 100%"
									v-b-popover.hover.top="`${candidateDetails.testName}`"
								>
									{{ candidateDetails.testName }}
								</span>
							</div>
						</div>
					</div>

					<hr />

					<div class="d-flex justify-content-between mt-3 mb-2">
						<div
							class="attempt-detail"
							style="font-weight: 500; font-size: 13px; color: #737373"
						>
							Attempts Details
						</div>
						<div
							class="attempt-detail"
							style="font-weight: 500; font-size: 11px; color: #737373"
						>
							No of Attempts : {{ candidateDetails.data.length }}
							<!--{{ singledata.totalAttempts }} -->
						</div>
					</div>

					<div class="cards-overflow">
						<div
							class="attempt-box-new d-flex flex-column mr-1"
							:class="index == 0 ? '' : 'mt-3'"
							v-for="(particularCandDetails, index) in candidateDetails.data"
							:key="index"
						>
							<div class="d-flex justify-content-between">
								<div
									class="groupheading"
									style="color: #696969; font-weight: 600"
								>
									Attempt {{ particularCandDetails.attemptNo }}
								</div>
							</div>
							<div class="d-flex justify-content-between">
								<div>
									<div class="attempt-heading-2">Marks Obtained</div>
									<div
										class="attempt-data"
										style="font-weight: 500; font-size: 14px; color: #5782ff"
									>
										{{ particularCandDetails.marks }}/{{
											particularCandDetails.totalTestMarks
										}}
									</div>
								</div>
								<div>
									<div class="attempt-heading-2">Result</div>
									<div
										class="attempt-data"
										style="font-weight: 500; font-size: 14px;"
									>
										<div
											v-if="
												particularCandDetails.evaluation &&
													particularCandDetails.isSubmitted
											"
										>
											<span
												:class="
													particularCandDetails.statusCode == 0
														? 'pr-fail'
														: 'pr-pass'
												"
												>{{ particularCandDetails.status }}</span
											>
										</div>
										<div
											v-else-if="
												particularCandDetails.testResponse.length == 0 &&
													!particularCandDetails.isSubmitted
											"
										>
											<span style="color: #AD1927;">
												Discontinued Test
											</span>
										</div>
										<div
											v-else-if="
												!particularCandDetails.isSubmitted &&
													particularCandDetails.testResponse.length != 0
											"
											style="color: #AD1927;"
										>
											Not Submitted
										</div>
										<div v-else style="color: #AD1927;">Not Evaluated</div>

										<!-- {{ i.maxMarks }} -->
									</div>
								</div>
								<div class="">
									<div class="attempt-heading-2">View Details</div>
									<div class="attempt-data">
										<img
											v-b-modal.viewdetailsmodal
											@click="viewCandidateModal(particularCandDetails)"
											src="../../assets/icons/proctoring/result.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-else-if="candidateDetails.data == ''">
					<div class="d-flex align-items-center justify-content-center h-100">
						<img src="../../assets/nogroupdata.svg" alt="" />
					</div>
				</template>
			</div>

			<!-- display individual test details -->
			<div v-else-if="$route.params.candidateType == 'I'">
				<template v-if="totalData">
					<div class="d-flex justify-content-between align-items-center">
						<div class="d-flex align-items-center">
							<img
								v-if="
									$route.params.candidateType == 'G' ||
										$route.params.candidateType == 'R'
								"
								src="../../assets/icons/Reports/bckarrow.svg"
								alt=""
								class="pointer"
								@click="closeParticularCandidate()"
							/>
							<div class="ml-1 canddet-txt">Candidate Details</div>
						</div>
						<div
							class="mr-1 pointer gotoprocttxt"
							v-if="
								tabIndex < 3 &&
									showProctoring != 'yetToStart' &&
									totalData.data.length > 0 &&
									roles.includes('GET_PROCTORING_DETAILS')
							"
							@click="$emit('store-payload'), gotoFourthPage(totalData)"
						>
							Go to proctoring
						</div>
					</div>
					<div class="d-flex align-items-center justify-content-between mt-4">
						<div class="d-flex align-items-center">
							<div class="pvd-profileimg">
								<img
									src="../../assets/icons/proctoring/dp.png"
									alt=""
									class="w-100 h-100"
								/>
							</div>
							<div class="d-flex pvd-dp-text flex-column ml-3">
								<div class="text-truncate">
									{{ totalData.candidatename }}
								</div>
								<div class="text-truncate">{{ totalData.email }}</div>
								<!-- <div>{{ singledata.name }}</div> -->
							</div>
						</div>
						<div
							class="pointer gotoprocttxt txt-underline"
							@click="exportExcelReport()"
						>
							Export Excel
						</div>
					</div>
					<div class="d-flex justify-content-between align-items-center mt-5">
						<div class="d-flex flex-column" style="width: 45%">
							<div class="answertext">Topic Name</div>
							<div class="text-truncate">
								<span
									class="d-inline-block quesbank-number-text text-truncate"
									style="max-width: 100%"
									v-b-popover.hover.top="
										`${getFormattedTopicName(totalData.topicName)}`
									"
								>
									{{ getFormattedTopicName(totalData.topicName) }}
								</span>
							</div>
						</div>
						<div class="d-flex flex-column" style="width: 55%">
							<div class="answertext">Test Name</div>
							<div class="text-truncate">
								<span
									class="d-inline-block quesbank-number-text text-truncate"
									style="max-width: 100%"
									v-b-popover.hover.top="`${totalData.testName}`"
								>
									{{ totalData.testName }}
								</span>
							</div>
						</div>
					</div>

					<hr />

					<div class="d-flex justify-content-between mt-3 mb-2">
						<div
							class="attempt-detail"
							style="font-weight: 500; font-size: 13px; color: #737373"
						>
							Attempts Details
						</div>
						<div
							class="attempt-detail"
							style="font-weight: 500; font-size: 11px; color: #737373"
						>
							No of Attempts : {{ totalData.data.length }}
							<!--{{ singledata.totalAttempts }} -->
						</div>
					</div>

					<div class="cards-overflow">
						<div
							class="attempt-box-new d-flex flex-column mr-1"
							:class="index == 0 ? '' : 'mt-3'"
							v-for="(particularCandDetails, index) in totalData.data"
							:key="index"
						>
							<div class="d-flex justify-content-between">
								<div
									class="groupheading"
									style="color: #696969; font-weight: 600"
								>
									Attempt {{ particularCandDetails.attemptNo }}
								</div>
							</div>
							<div class="d-flex">
								<div style="width: 40%;">
									<div class="attempt-heading-2">Marks Obtained</div>
									<div
										v-if="particularCandDetails.evaluation == false"
										class="ml-4"
									>
										--
									</div>
									<div
										v-else
										class="attempt-data"
										style="font-weight: 500; font-size: 14px; color: #5782ff"
									>
										{{ particularCandDetails.marks }}/{{
											particularCandDetails.totalTestMarks
										}}
									</div>
								</div>
								<div style="width: 40%;">
									<div class="attempt-heading-2">Result</div>
									<div
										class="attempt-data"
										style="font-weight: 500; font-size: 14px;"
									>
										<div
											v-if="
												particularCandDetails.evaluation &&
													particularCandDetails.isSubmitted
											"
										>
											<span
												:class="
													particularCandDetails.statusCode == 0
														? 'pr-fail'
														: 'pr-pass'
												"
												>{{ particularCandDetails.status }}</span
											>
										</div>
										<div
											v-else-if="
												particularCandDetails.testResponse.length == 0 &&
													!particularCandDetails.isSubmitted
											"
										>
											<span style="color: #AD1927;">
												Discontinued Test
											</span>
										</div>
										<div
											v-else-if="
												!particularCandDetails.isSubmitted &&
													particularCandDetails.testResponse.length != 0
											"
											style="color: #AD1927;"
										>
											Not Submitted
										</div>
										<div v-else style="color: #AD1927;">Not Evaluated</div>
										<!-- {{ i.maxMarks }} -->
									</div>
								</div>
								<div style="width: 20%;">
									<div class="attempt-heading-2">View Details</div>
									<div class="attempt-data d-flex justify-content-center mt-1">
										<img
											v-b-modal.viewdetailsmodal
											@click="viewCandidateModal(particularCandDetails)"
											src="../../assets/icons/proctoring/result.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-else-if="totalData == ''">
					<div class="d-flex align-items-center justify-content-center h-100">
						<img src="../../assets/nogroupdata.svg" alt="" />
					</div>
				</template>
			</div>
			<b-modal
				id="viewdetailsmodal"
				centered
				hide-footer
				hide-header
				size="md"
				class=""
			>
				<div
					class="viewmark-heading pl-2 pr-2 d-flex align-items-center justify-content-between"
				>
					Attempt {{ particularCandidatestore.attemptNo }} Details
				</div>
				<hr />
				<div class="xMarkCancel" @click="$bvModal.hide('viewdetailsmodal')">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<div class="vpt-namebox mt-3">
					<div class="d-flex justify-content-between">
						<div
							class="viewmark-testbox-headtestname"
							style="margin-top: 15px; margin-left: 15px; color: #696969"
						>
							Name
						</div>
						<div
							class="viewmark-testbox-subtestname"
							style="margin-top: 15px; margin-right: 15px"
						>
							{{ particularCandidatestore.name }}
							<!-- {{ singledata.name }} -->
						</div>
					</div>
				</div>
				<div class="vptd-details-sections">
					<div>
						<div class="view-details-main mt-3">
							<div class="d-flex justify-content-between">
								<div class="attempt-section" style="color: #6d6d6d">
									Test name
								</div>
								<div
									v-if="Object.keys(particularCandidatestore.stats).length == 0"
									class="attempt-section"
									style="color: #6D6D6D;"
								>
									Date : -
								</div>
								<div v-else class="attempt-section" style="color: #6D6D6D;">
									Date :
									{{
										formatDate(
											particularCandidatestore.stats.timing.startTime,
											"dd-MM-yyyy"
										)
									}}
								</div>
							</div>
							<div class="d-flex justify-content-between">
								<div class="attempt-section ellipsis" style="width: 50%">
									{{ particularCandidatestore.testName }}
								</div>
								<div
									v-if="
										particularCandidatestore.testResponse &&
											particularCandidatestore.testResponse.length == 0 &&
											!particularCandidatestore.isSubmitted
									"
									style="color: #AD1927;"
								>
									Discontinued Test
								</div>
								<div
									v-else-if="
										particularCandidatestore.evaluation &&
											particularCandidatestore.isSubmitted
									"
								>
									<span class="viewmark-testbox-subtestname">Result: </span>
									<span
										:class="
											particularCandidatestore.statusCode == 0
												? 'pr-fail'
												: 'pr-pass'
										"
										>{{ particularCandidatestore.status }}</span
									>
								</div>
								<div
									v-else-if="
										!particularCandidatestore.isSubmitted &&
											particularCandidatestore.testResponse &&
											particularCandidatestore.testResponse.length != 0
									"
									style="color: #AD1927;"
								>
									Not Submitted
								</div>
								<div v-else style="color: #AD1927;">Not Evaluated</div>
							</div>
							<div
								v-if="
									particularCandidatestore.evaluation &&
										particularCandidatestore.testResponse &&
										particularCandidatestore.testResponse.length != 0
								"
								style="height: calc(100vh - 475px);
    overflow-y: auto;padding-right: 5px;"
							>
								<div
									class="attempt-section d-flex justify-content-between mt-3"
								>
									<div class="d-flex">
										<div>
											<img
												src="../../assets/icons/proctoring/result.svg"
												alt=""
											/>
										</div>
										<div class="ml-1">Marks</div>
									</div>
									<div>
										Total Marks : {{ particularCandidatestore.marks }}/{{
											particularCandidatestore.totalTestMarks
										}}
									</div>
								</div>
								<div
									class="section-detail-main p-3"
									v-for="(secdetail,
									index) in particularCandidatestore.testResponse"
									:key="index"
								>
									<div class="view-details-submain">
										<div class="d-flex justify-content-between">
											<div class="ml-2 attempt-section">
												{{ secdetail.sectionName }}
												<!-- {{ i.sectionName }} -->
											</div>
											<div
												class="mr-2 attempt-name-show"
												:style="cssForDynamicColor"
											>
												{{ secdetail.sectionMarks }}/{{
													secdetail.serctionTotalMarks
												}}
												<!-- {{ i.sectionMarks }} / {{ i.sectionTotalMarks }} -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div
							class="viewmark-open-atmpt-box d-flex align-items-center position-relative pointer p-2"
						>
							<div class="attempt-section ml-3">Address</div>
						</div>

						<div class="viewmark-attempt-open-box p-2 pl-2 align-items-center">
							<div class="d-flex align-items-center mt-2">
								<div>
									<img src="../../assets/icons/proctoring/Email.svg" alt="" />
								</div>
								<div
									class="address-text ml-4"
									v-if="particularCandidatestore.stats.geolocation != undefined"
								>
									{{
										particularCandidatestore.stats.geolocation.address
											.formatted_address
									}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-modal>
		</div>
	</b-overlay>
</template>
<script>
import {
	// getProcteringAllTests,
	// getEvalTestCandidates,
	getproctoringCandidates,
	getExcelReport,
	// getProcteringFilter,
	// postTaggedEvalTest,
} from "../../utils/apiFunctions.js";
import { mapGetters } from "vuex";
import errorToast from "../../views/mixin/toast";

export default {
	name: "ViewProctorTestDetails",
	props: {
		allData: {
			type: Object,
		},
		showSpinner: Boolean,
		particularView: Boolean,
		showProctoring: String,
		tabIndex: Number,
		queryName: String,
		querySummary: String,
		queryEvaluated: String,
		queryGroups: String,
		querySort: Number,
		queryStatus: String,
	},

	mixins: [errorToast],

	data() {
		return {
			showDiv: false,
			showName: false,
			LoaderStatus: false,
			filterPageEnd: null,
			totalFilterData: null,
			showtypecard: false,
			selTopicName: "",
			page: 0,
			testCount: "50",
			searchFilter: "",
			typeselected: "2",
			onclickeye: true,
			groupcards: 9,
			selectFirstCard: {},

			// testCardselected: 'Active',

			candidatesDetails: {
				data: [],
			},
			totalData: {
				data: [],
			},
			typeoptions: [
				{ text: "All", value: "2" },
				{ text: "Active", value: "1" },
				{ text: "Inactive", value: "0" },
			],
			singleCandidatesDetails: {},
			candidateImage: "",
			candDetails: {},
			allCandidates: [],
			sectionDetails: [],
			testCardselected: "Active",
			activeForTest: "true",
			individualMarks: {},
			showGroups: false,
			gettests: [],
			totaltests: {},
			candidateDetails: {},
			selectedGroup: {
				groupName: "",
				createdAt: "",
				candidates: [],
			},
			testTypeOptions: [
				{ text: "All", value: "" },
				{ text: "Active", value: "true" },
				{ text: "Inactive", value: "false" },
			],
			groups: [],
			name: "",
			pageStart: "",
			status: "",
			pageEnd: "",
			prevPg: "",
			// showSpinner: false,
			showtest: false,
			showtestcard: false,
			total: null,
			currentPage: 1,
			curPage: 1,
			sortOrder: -1,
			count: 10,
			sortorder: false,
			sorting: false,
			applyfilter: false,
			goToPage: null,
			totalPages: null,
			addressView: false,
			particularCandidatestore: {
				stats: {
					timing: {
						startTime: "",
					},
				},
			},
			storeTopic: {},
			storeTab: "",
			sortcolumn: "",
			getTestid: "",
			showtestconfig: false,
			topicName: "",
			showviewgroup: true,
			nodata: false,
			sortColumn: "createdAt",
			candidateID: "",
			filterview: false,
			filterTopic: [],
			filterTest: [],
			selectedTest: [],
			selectedTopic: [],
			selectedTopicIndex: null,
			testConfigData: {
				config: {
					dispCount: "",
				},
			},

			completed: null,
			ongoing: null,
			viewCandidate: false,
		};
	},
	computed: {
		cssForDynamicColor() {
			return {
				"--dynamicBorderColor":
					"#" +
					Math.random()
						.toString(16)
						.substr(-6),
			};
		},
		...mapGetters(["roles"]),
	},
	watch: {
		//watches prop value for particular candidate details view
		// particularView(newvalue, oldvalue) {
		//   if (newvalue != oldvalue) {
		//     this.viewparticular = newvalue;
		//   }
		//   console.log(this.viewparticular, "Watcher");
		// },
		//watches prop value all data and assigns to local variable whenever value changes
		allData(newvalue, oldvalue) {
			if (newvalue != oldvalue) {
				this.totalData = newvalue;
			}
		},
	},
	methods: {
		//go to proctoring
		getFormattedTopicName(topicName) {
			if (topicName === "Sandbox-KSGPdd3q0S#jl@B") return "Sandbox";
			else return topicName;
		},
		async gotoFourthPageGroup(data) {
			this.$router.push({
				path: `/proctoring/evaluatetest/${data.testID}/${data.topicID}/${data.groupID}/${data.candidateID}/${this.$route.params.candidateType}?name=${this.$route.query.name}`,
			});
		},
		async gotoFourthPage(totdata) {
			this.$router.push({
				path: `/proctoring/evaluatetest/${totdata.data[0].testID}/${totdata.data[0].topicID}/${totdata.data[0].groupID}/${totdata.data[0].candidateID}/${this.$route.params.candidateType}`,
				query: {
					name: this.$route.query.name,
					testName: totdata.data[0].testName,
					...(this.$route.params.candidateType == "G" && {
						userName: totdata.email,
					}),
				},
			});
		},
		// get api to fetch candidate details
		async getProctorCandDetails(value) {
			let payload = {
				topicID: value.topicID,
				testID: value.testID,
				groupID: value.groupID,
				candidateID: value.candidateID,
			};
			const res = await getproctoringCandidates(payload);
			if (res.status == 200) {
				this.candidateDetails = res.data.data;
			}
		},
		// closes detailed candidate test details view
		closeParticularCandidate() {
			this.particularView = false;
		},
		// View particular candidate details in the group
		viewParticularCandidate(data) {
			this.storeTopic = data;
			this.particularView = true;
			this.getProctorCandDetails(data);
		},
		// open view details modal
		viewCandidateModal(data) {
			this.particularCandidatestore = data;
		},
		//download excel report
		async exportExcelReport() {
			try {
				let payload = {
					testID: this.allData.data[0].testID,
					groupID: this.$route.params.groupID,
				};
				const res = await getExcelReport(payload);
				if (res.status == 200) {
					const url = window.URL.createObjectURL(
						new Blob([res.data], {
							type:
								"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
						})
					);

					const link = document.createElement("a");
					link.href = url;
					link.download = "Hire3x Report.xlsx";
					link.click();
				}
			} catch (error) {
				console.log(error);
			}
		},
		formatDate(inputDate, format) {
			const date = new Date(inputDate);
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			format = format.replace("MM", month.toString().padStart(2, "0"));
			if (format.indexOf("yyyy") > -1) {
				format = format.replace("yyyy", year.toString());
			} else if (format.indexOf("yy") > -1) {
				format = format.replace("yy", year.toString().slice(-2));
			}
			format = format.replace("dd", day.toString().padStart(2, "0"));
			return format;
		},
	},
};
</script>
<style>
.gotoprocttxt {
	color: #72738e;
	font-size: 15px;
	font-weight: 600;
	text-decoration-line: underline;
}
.canddet-txt {
	color: #72738e;
	font-size: 15px;
	font-weight: 600;
}
.sorttext {
	font-family: "Poppins";
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}

.vptsortcontainer {
	background: #fcfcfc;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border: 1px solid #72738e;

	border-radius: 3px;
	padding: 5px 15px;
	text-align: left;
}

.vpt-reportbtn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 95px;
	text-align: center;
}
.proct-content-container {
	height: calc(100vh - 140px);
}
.proct-test-viewcontainer .nav-tabs {
	border-bottom: 1px solid #dbdbe2;
}
.vpt-paginaTion {
	/* position: absolute; */
	width: 100%;
	padding: 10px;
	/* bottom: 0px; */
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

.proct-test-viewcontainer {
	/* background: #ffffff; */
	width: 70%;
	height: calc(100vh - 195px);
	position: relative;
	/* overflow: auto; */
}
.proct-test-viewcontainer-full {
	/* background: #ffffff; */
	width: 100%;
	height: calc(100vh - 195px);
	position: relative;
	/* overflow: auto; */
}

.tabbed ul li a:before {
	top: -2px;
	height: 110%;
}

.nav-tabs {
	border-bottom: none;
	overflow: hidden;
}

.proct-gicards {
	background: #ffffff;
	border: 2px solid #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
	position: relative;
	margin-right: 3px;
}
.proct-gicards-selected {
	background: #ebf5fe;
	border: 2px solid #84bae7;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
	position: relative;
	margin-right: 3px;
}

.proct-gicards-gridcolorbar {
	width: 4px;
	background: #f04e92;
	border-radius: 2px;
	position: absolute;
	left: 5px;
	top: 5px;
	height: 90%;
}

.proct-grpname {
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
}

.proct-gt-tctxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.proct-gt-tccounttxt {
	font-weight: 500;
	font-size: 14px;
	color: #84a3fe;
}

.active-btn {
	width: 81px;
	height: 23px;
	background: #ccfacb;
	border-radius: 3px;
}

.vpt-activetxt {
	font-weight: 400;
	font-size: 12px;
	color: #038e00;
}

.inactive-btn {
	width: 81px;
	height: 23px;
	background: #ffeeee;
	border-radius: 3px;
}

.inactive-text-proc {
	font-weight: 400;
	font-size: 12px;
	color: #ad1927;
}

.vpt-test-tab-container {
	height: calc(100vh - 245px);
	overflow: auto;
}

.grpviewselectedCandidateContainer {
	height: calc(100vh - 366px);
	overflow-y: auto;
}

.twobtns {
	position: absolute;
	bottom: 170px;
	right: 20px;
}

.cancelbtntext {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
}

.address-text {
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
}

.email {
	border: 1px solid #f4f4f4;
}

.proct-notest-container {
	height: calc(100vh - 210px);
}
.pr-test-cj-filter-modal {
	padding: 10px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
	border-radius: 5px;
	z-index: 6;
	position: absolute;
	width: 355px;
	height: 320px;
	right: 100px;
	top: 55px;
}
.pr-test-sortcard {
	background: var(--bg-white);
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
	border-radius: 5px;
	top: 55px;
	right: 10px;
	padding: 5px 15px;
	position: absolute;
	z-index: 7;
	font-size: var(--size-13);
	color: #545454;
}
.viewmark-heading {
	font-weight: 600;
	font-size: 13px;
	color: #545454;
}
.viewmark-testbox-subtestname {
	font-weight: 400;
	font-size: 14px;
	color: #696969;
}
.viewmark-date-txt {
	font-weight: 400;
	font-size: 12px;
	color: #6d6d6d;
}
.viewmark-section-txt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
/* #viewdetailsmodal .modal-content {
  border-radius: 10px;
  height: 80vh;
} */
.viewmark-attempt-open-box {
	background: #f8f8f8;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	margin-bottom: 15px;
}
.viewmark-open-atmpt-box {
	background: #f5f5f5;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 6px 6px 0px 0px;
	padding: 15px !important;
	margin-top: 15px;
}
/* .view-details-main {
  overflow-y: auto;
} */
.vptd-details-sections {
	overflow-y: auto;
	height: 580px;
}
.txt-underline {
	text-decoration: underline;
}
</style>
